import { render, staticRenderFns } from "./WDMaturingLeasInfo.vue?vue&type=template&id=4553d6d7&"
import script from "./WDMaturingLeasInfo.vue?vue&type=script&lang=js&"
export * from "./WDMaturingLeasInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports